import { render, staticRenderFns } from "./SlipDeliverySettings.vue?vue&type=template&id=69435963"
import script from "./SlipDeliverySettings.vue?vue&type=script&lang=js"
export * from "./SlipDeliverySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports